import { QueryClient } from "@tanstack/react-query";

// We don't auto-retry queries or mutations:
//
// 1. React Query's retryer pauses between attempts whenever
//    `focusManager.isFocused()` is false — and there is no networkMode that
//    skips that gate. A briefly unfocused window (devtools open, tab switch)
//    strands the request in `fetchStatus: 'paused' / status: 'pending'` and
//    isError never fires. Consumers like `RegistrationInvoiceDrafts` and
//    `PaymentForm` then sit on their loading spinner forever instead of
//    rendering `RmQueryError` (RAM-28) or the friendly mutation toast.
// 2. Most failures here are permanent (RLS 403, unique-constraint 23505,
//    auth) — retries can't recover them and just delay the error UI.
// 3. RmQueryError already has a Retry button that refetches on demand, so
//    the user has the manual recovery path.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
